import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="preview-modal"
export default class extends Controller {
  static targets = ["dialog"];

  connect() {
    if (this.element.dataset.openOnConnect === "true") this.open();
  }

  open() {
    this.dialogTarget.classList.remove("hidden");
    this.dialogTarget.classList.add("flex");
    this.dialogTarget.querySelector("input[type=password]")?.focus();
  }

  close() {
    this.dialogTarget.classList.add("hidden");
    this.dialogTarget.classList.remove("flex");
  }
}
